document.addEventListener('DOMContentLoaded', function() {
  /* This script is used to calculate the delivery date for a product (on the product page) */
  // 1. "Canary" log to confirm the script is running.
  //console.log('%c[Delivery Estimator] Script loaded and DOM is ready.', 'color: green; font-weight: bold;');

  try {
    const deliveryNotice = document.getElementById('delivery_notice');
    const productSection = document.querySelector('[data-section-type="product"]');
    // 2. Made this selector more generic to work across different templates.
    const productJsonElement = document.querySelector('[data-product-json]');
    
    // --- Guard Clauses: Exit if essential elements are not found ---
    if (!deliveryNotice) {
      console.warn("Delivery notice element with ID 'delivery_notice' not found. Estimator will not run.");
      return;
    }
    if (!productSection) {
      console.warn("Product section with attribute 'data-section-type=\"product\"' not found. Estimator cannot listen for variant changes.");
      return;
    }
     if (!productJsonElement) {
      console.error("Product JSON element with attribute 'data-product-json' not found. Estimator cannot get initial SKU.");
      return;
    }

    const calculateDeliveryDate = (sku) => {
      try {
        if (!sku) {
          deliveryNotice.innerHTML = '';
          return;
        }
        
        //console.log(`%c[Delivery Estimator] Calculating for SKU: ${sku}`, 'color: blue;');

        const currentDate = new Date();
        let deliveryDays;
        const lowerCaseSku = sku.toLowerCase();

        if (lowerCaseSku.includes('_can-')) {
          //console.log('[Delivery Estimator] SKU match: Canvas (_can-)');
          deliveryDays = currentDate.getHours() < 11 ? 1 : 2; // Canvas
        } else if (lowerCaseSku.includes('_pos-')) {
          //console.log('[Delivery Estimator] SKU match: Poster (_pos-)');
          deliveryDays = currentDate.getHours() < 8.5 ? 1 : 2; // Poster
        } else if (lowerCaseSku.includes('_frm-')) {
          //console.log('[Delivery Estimator] SKU match: Enmarcado (_frm-)');
          deliveryDays = currentDate.getHours() < 8.5 ? 1 : 2; // Enmarcado
        } else if (lowerCaseSku.includes('_pix-')) {
          //console.log('[Delivery Estimator] SKU match: Pixsets (_pix-)');
          deliveryDays = currentDate.getHours() < 14 ? 4 : 5; // Pixsets
        } else if (lowerCaseSku.includes('_acr-')) {
          //console.log('[Delivery Estimator] SKU match: Acrílico (_acr-)');
          deliveryDays = currentDate.getHours() < 8 ? 8 : 9; // Acrílico
        } else if (lowerCaseSku.includes('_kdc-')) {
          //console.log('[Delivery Estimator] SKU match: KDC (_kdc-)');
          deliveryDays = currentDate.getHours() < 12 ? 1 : 2; // Kit de Collage
        }else {
          //console.log('[Delivery Estimator] SKU did not match any specific case. Using default.');
          deliveryDays = 1; // Default
        }

        let deliveryDate = new Date(currentDate);
        let daysToAdd = deliveryDays;
        while (daysToAdd > 0) {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
          const dayOfWeek = deliveryDate.getDay();
          if (dayOfWeek !== 0 && dayOfWeek !== 6) { // 0 = Sunday, 6 = Saturday
            daysToAdd--;
          }
        }

        // Adjust if the final date lands on a weekend
        if (deliveryDate.getDay() === 6) { // If it's Saturday
          deliveryDate.setDate(deliveryDate.getDate() + 2); // Move to Monday
        } else if (deliveryDate.getDay() === 0) { // If it's Sunday
          deliveryDate.setDate(deliveryDate.getDate() + 1); // Move to Monday
        }

        const options = { weekday: 'long', month: 'long', day: 'numeric' };
        const formattedDate = deliveryDate.toLocaleDateString('es-ES', options);
        const uppercaseDate = formattedDate.toUpperCase();

        deliveryNotice.innerHTML = `<p><b>Fecha estimada de entrega con envío Express: ${uppercaseDate}</b></p>`;
      } catch (e) {
        console.error('Error during delivery date calculation:', e);
        deliveryNotice.innerHTML = '';
      }
    };

    // --- Listen for variant changes ---
    productSection.addEventListener('variant:changed', function(event) {
      if (event.detail.variant && event.detail.variant.sku) {
        calculateDeliveryDate(event.detail.variant.sku);
      }
    });

    // --- Initial calculation on page load ---
    const productData = JSON.parse(productJsonElement.textContent);
    
    // Use the selected_variant_id from the JSON, which works for all product types.
    if (productData.selected_variant_id) {
      const initialVariantId = productData.selected_variant_id;
      const initialVariant = productData.product.variants.find(v => v.id === initialVariantId);

      if (initialVariant && initialVariant.sku) {
        calculateDeliveryDate(initialVariant.sku);
      }
    }
    
  } catch (e) {
    console.error('An unexpected error occurred while initializing the delivery date calculator:', e);
  }
});